/**
 * trk click Trace logger
 * @param clickTraceStr
 */
const trace = (clickTraceStr) =>{
    if(typeof _trk_clickTrace !== 'function') {
        window._trk_clickTrace = function(param1, param2){
            console.log(`_trk_clickTrace('${param1}','${param2}')`);
        };
    }

    _trk_clickTrace('EVT', clickTraceStr);
};

export default trace;